// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app #app-main .edi-state-query-dialog[data-v-019b49c4]  .el-select__tags {\n  padding-left: 10px;\n}\n#app #app-main .edi-state-query-dialog[data-v-019b49c4]  .el-select__tags span {\n    display: contents;\n    height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
